import React, { Component } from 'react';
import { Grid, Col, Row } from 'react-bootstrap';
import GooglePlusWidget from './GooglePlusWidget';
import i18n from 'kodyl-js/i18n/react';
import DocumentMeta from 'react-document-meta';

@i18n
class About extends Component {
  render() {
    const docMeta = {
      title: this.i18n('About Boligninja.dk'),
      extend: true,
      auto: {
        ograph: true
      }
    };

    return (
      <DocumentMeta {...docMeta}>
        <Grid>
          <Row>
            <Col xs={12}>
              <h1>{this.i18n('About Boligninja.dk')}</h1>
              <GooglePlusWidget />

              <p>Boligninja.dk er simpel boligsøgning i trygge rammer.</p>

              <p>
                Som lejer kan du søge efter din nye bolig, samt kontakte
                udlejerne. Det eneste du skal gøre er at oprette en brugerprofil
                og en Boligsøgerannonce.
              </p>

              <p>
                Du kan også oprette en BoligAgent, der sørger for, at du får
                mail hver gang en ny bolig matcher dine krav.
              </p>
            </Col>
          </Row>
        </Grid>
      </DocumentMeta>
    );
  }
}

export default About;
